import React, { useState } from 'react';
import BookingForm from '../components/BookingForm';
import GiftVoucherForm from '../components/GiftVoucherForm';
import Reveal from '../components/Reveal';
import '../assets/styles/book_now.css';

function Book_now() {
  const [view, setView] = useState('booking');

  return (
    <div className="book-now-page">
      <Reveal variant="up" duration={0.55}>
        <h1>Book an Appointment</h1>
        <p className="booking-eyebrow">Viktoria will confirm your appointment shortly after receiving your request.</p>
      </Reveal>

      <Reveal variant="up" delay={0.1} duration={0.5}>
        <div className="booking-tab-row">
          <div className="booking-tab-group" role="tablist" aria-label="Booking options">
            <button
              role="tab"
              aria-selected={view === 'booking'}
              className={`booking-tab-btn${view === 'booking' ? ' active' : ''}`}
              onClick={() => setView('booking')}
            >
              Book Appointment
            </button>
            <button
              role="tab"
              aria-selected={view === 'voucher'}
              className={`booking-tab-btn${view === 'voucher' ? ' active' : ''}`}
              onClick={() => setView('voucher')}
            >
              Gift Voucher
            </button>
          </div>
        </div>
      </Reveal>

      <Reveal variant="up" delay={0.2} duration={0.55}>
        <div className="booking-container" role="tabpanel">
          {view === 'booking' ? <BookingForm /> : <GiftVoucherForm />}
        </div>
      </Reveal>
    </div>
  );
}

export default Book_now;
